import { render, staticRenderFns } from "./AfterConfirmedOrder.vue?vue&type=template&id=4a0fd012&scoped=true"
import script from "./AfterConfirmedOrder.vue?vue&type=script&lang=js"
export * from "./AfterConfirmedOrder.vue?vue&type=script&lang=js"
import style0 from "./AfterConfirmedOrder.vue?vue&type=style&index=0&id=4a0fd012&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0fd012",
  null
  
)

export default component.exports